import "./App.css";
import Layout from "./components/common/layout";
import { Router } from "./components/routes";
import Login from "./components/Login";
import { API_URI } from "./components/Constants";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess, logout } from "./redux/authSlice";

function App() {

  const dispatch = useDispatch();

  const { isLoggedIn, user, tokenExpiryTime } = useSelector(
    (state) => state.auth
  );

  // LOGIN
  const handleCustomLogin = useCallback(async ({ email, password }) => {

    try {

      const res = await axios.post(
        `${API_URI}/login`,
        { email, password },
        { withCredentials: true }
      );

      if (res.data?.accessToken) {

        const { accessToken, user } = res.data;

        const expiryTime = Date.now() + 15 * 60 * 1000;

        dispatch(
          loginSuccess({
            user,
            accessToken,
            tokenExpiryTime: expiryTime,
          })
        );
      }

    } catch (error) {
      console.error("Login error:", error.response?.data || error);
      throw error;
    }

  }, [dispatch]);


  // TOKEN REFRESH
  const attemptTokenRefresh = useCallback(async () => {

    try {

      const res = await axios.post(
        `${API_URI}/refresh-token`,
        {},
        { withCredentials: true }
      );

      if (res.data?.accessToken) {

        const newExpiry = Date.now() + 15 * 60 * 1000;

        dispatch(
          loginSuccess({
            user,
            accessToken: res.data.accessToken,
            tokenExpiryTime: newExpiry,
          })
        );

        return true;
      }

    } catch (err) {
      console.warn("Token refresh failed:", err.response?.data || err.message);
    }

    return false;

  }, [dispatch, user]);


  // LOGOUT
  const handleLogout = useCallback(async () => {

    try {
      await axios.post(`${API_URI}/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.warn("Logout API failed:", error);
    } finally {
      dispatch(logout());
    }

  }, [dispatch]);


  useEffect(() => {
    if (!tokenExpiryTime) return;
    const timeLeft = tokenExpiryTime - Date.now();
    if (timeLeft <= 0) {
      attemptTokenRefresh().then((refreshed) => {
        if (!refreshed) handleLogout();
      });
      return;
    }

    const refreshTimeout = setTimeout(() => {
      attemptTokenRefresh().then((refreshed) => {
        if (!refreshed) handleLogout();
      });
    }, Math.max(timeLeft - 60000, 0));
    return () => clearTimeout(refreshTimeout);
  }, [tokenExpiryTime, attemptTokenRefresh, handleLogout]);


  return (
    <BrowserRouter>
      {isLoggedIn ? (
        <Layout userData={user} onLogout={handleLogout}>
          <Router />
        </Layout>
      ) : (
        <Login handleCustomLogin={handleCustomLogin} />
      )}
    </BrowserRouter>
  );
}

export default App;